<div [formGroup]="form">
  <p-selectButton [options]="stateOptions" optionLabel="label" optionValue="value"
                  [formControlName]="fieldName" [allowEmpty]="false"/>
</div>
